import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AddToCartButton from "../cart/AddToCartButton";
import { productDetailPath } from "../../constants/routes";

function getDisplayCategory(categories = []) {
  return categories.find((category) => category.slug !== "uncategorized");
}

function ProductCard({ product, showAddToCart = false }) {
  const { t } = useTranslation();
  const detailPath = productDetailPath(product.slug);
  const category = getDisplayCategory(product.categories);

  return (
    <article className="caf-product-card group">
      <Link to={detailPath} className="caf-product-card__link">
        <div className="caf-product-card__media">
          {product.image ? (
            <img
              src={product.image}
              alt={product.name}
              className="caf-product-card__image"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="caf-product-card__placeholder" aria-hidden="true" />
          )}
        </div>
        <div className="caf-product-card__body">
          {category ? (
            <p className="caf-product-card__category">{category.name}</p>
          ) : null}
          <h3 className="caf-product-card__title">{product.name}</h3>
          {product.shortDescription ? (
            <p className="caf-product-card__excerpt">{product.shortDescription}</p>
          ) : null}
        </div>
      </Link>

      <div className="caf-product-card__footer">
        {product.formattedPrice ? (
          <span className="caf-product-card__price">{product.formattedPrice}</span>
        ) : (
          <span className="caf-product-card__price caf-product-card__price--quote">
            {t("Request a Quote")}
          </span>
        )}

        {showAddToCart ? (
          <AddToCartButton
            product={product}
            className="caf-btn caf-btn--primary caf-product-card__cart-btn"
          />
        ) : (
          <Link to={detailPath} className="caf-product-card__cta">
            {t("View product")}
          </Link>
        )}
      </div>
    </article>
  );
}

export default ProductCard;
